module.exports = __webpack_public_path__ + "img/orach-350x184.508766f8.jpg";